import {
  Box,
  Chip,
  Grid,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";

import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import theme from "../../styles/styleTheme";
import styled from "styled-components";
import { formatCurrency } from "../../utils/currency";
import { useTranslation } from "react-i18next";
import { BoxPaper } from "../common/BoxPaper";

type TenantCheckFormHeaderProps = {
  property: any;
};

const TenantCheckFormHeader = ({ property }: TenantCheckFormHeaderProps) => {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <BoxPaper>
      <Grid item>
        <Grid item xs={12}>
          <Typography
            display={"flex"}
            variant={isSmallScreen ? "h3" : "h2"}
            gap={1}
          >
            <ContentPasteOutlinedIcon color="primary" />
            {t("screening.header.title")}
          </Typography>
        </Grid>
        {property ? (
          <Grid marginTop={2} item xs={12} gap={1}>
            <Box
              display={"flex"}
              gap={2}
              flexDirection={isSmallScreen ? "column" : "row"}
            >
              <Chip
                size={isSmallScreen ? "small" : "medium"}
                color="primary"
                icon={<HomeWorkOutlinedIcon />}
                sx={{
                  backgroundColor: theme.palette.primary.light,
                  color: theme.palette.primary.main,
                }}
                label={
                  <Typography display={"flex"} variant="body1" gap={1}>
                    {property?.title}
                  </Typography>
                }
              />
              <Chip
                size={isSmallScreen ? "small" : "medium"}
                sx={{
                  backgroundColor: theme.palette.primary.light,
                  color: theme.palette.primary.main,
                }}
                color="primary"
                label={
                  <Typography>
                    {formatCurrency(property?.propertyDetails?.minimumRent)}{" "}
                    {t("screening.header.per_month")}
                  </Typography>
                }
              />
            </Box>
          </Grid>
        ) : (
          <Skeleton variant="text" height={50} width={300} />
        )}

        <Grid item xs={12}>
          <Typography variant="body1" marginTop={3}>
            {t("screening.header.description")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" marginTop={2}>
            {t("screening.header.check_info")}
          </Typography>
        </Grid>
      </Grid>
    </BoxPaper>
  );
};

export default TenantCheckFormHeader;
